/* eslint-disable @typescript-eslint/no-unsafe-return */

import {FunctionalComponent, h} from "@stencil/core";
import {CheckboxCell, TableHeader, TableIconHeader, TableSkeleton, TextCell, Topic} from "./notification-settings.sub";
import type {ICategory, IUserSettingsCategory} from "@trumpf/notifies.user-settings-handler";

export const ChannelsSection: FunctionalComponent<{
	topic: {headlineSlot: string; textSlot: string};
	table: {
		categoryHeaderSlot: string;
		notificationChannel: {headerSlot: string; tooltip: string};
		eMailChannel: {headerSlot: string; tooltip: string};
	};
	isLoading: boolean;

	//! merge both in the store
	categories: ICategory[];
	userSettingsCategories: IUserSettingsCategory[];

	updateChannel: (category: string, channel: string, enabled: boolean) => void;
}> = ({topic, table, isLoading, categories, userSettingsCategories, updateChannel}) => {
	//! to be removed once categories & userSettingsCategories are merged in the store
	const xCategories =
		categories.length > 0 && userSettingsCategories.length > 0
			? categories.map((category) => ({
					...category,
					channels: userSettingsCategories.find((settingsCategory) => settingsCategory.name === category.name).channels,
				}))
			: [];

	// always sort system-generated category (if found) to the end of the array
	const sortedCategories = xCategories.sort((a, b) => {
		if (a.name === "system-generated") return 1;
		if (b.name === "system-generated") return -1;
		return 0;
	});

	return (
		<section>
			<Topic headlineSlot={topic.headlineSlot} textSlot={topic.textSlot} />
			<ux-table class="u-marginBottom-50" fullWidth mobileAccordion={false}>
				<table>
					<thead>
						<tr>
							<TableHeader headerSlot={table.categoryHeaderSlot} />
							<TableIconHeader headerSlot={table.notificationChannel.headerSlot} icon="square-info" tooltip={table.notificationChannel.tooltip} />
							<TableIconHeader headerSlot={table.eMailChannel.headerSlot} icon="square-info" tooltip={table.eMailChannel.tooltip} />
						</tr>
					</thead>
					<tbody>
						{isLoading ? (
							<TableSkeleton columns={3} rows={2} />
						) : (
							sortedCategories.map((category) => {
								const notificationChannel = category.channels.find((channel) => channel.name === "notificationChannel");
								const eMailChannel = category.channels.find((channel) => channel.name === "eMailChannel");

								return (
									<tr>
										<TextCell text={category.title} info={{icon: "square-info", tooltip: category.tooltip}} />
										<CheckboxCell
											name={notificationChannel.name}
											disabled={category.businessCritical}
											isChecked={notificationChannel.enabled}
											onChange={(e) => updateChannel(category.name, notificationChannel.name, (e.target as HTMLInputElement).checked)}
										/>
										<CheckboxCell
											name={eMailChannel.name}
											disabled={category.businessCritical}
											isChecked={eMailChannel.enabled}
											onChange={(e) => updateChannel(category.name, eMailChannel.name, (e.target as HTMLInputElement).checked)}
										/>
									</tr>
								);
							})
						)}
					</tbody>
				</table>
			</ux-table>
		</section>
	);
};
